<template>
	<div class="listbox">
		<div class="common-header-wrap">
			<mt-header class="common-header" title="10 Exhibition Topics">
				<mt-button icon="back" slot="left" @click="$router.go(-1)"></mt-button>		
			</mt-header>
		</div>
		<div class="LogoBannerBox">
			<div class="LogoBannerBoxbj">
				<img src="../../../assets/image/live/livebanner.jpg?v=01" />
			</div>
			<div class="LogoBannerTextBox">
				<div class="LiveLogoBox">
					<!--<img src="https://trust-data.oss-cn-shenzhen.aliyuncs.com/file/upload/20220514/401_1652491526738684.png" />-->
				</div>
				
					
			</div>
			
		</div>
		
		<div class="LiveProductListBoxs">
			<div class="ClassListBox">
					
					<p @click="classlistshow()" class="classlistshowst">10 Exhibition Topics</p>
					<p @click="loginbox()" class="classlogins">Login/Register</p>
				</div>
			
			
			<div class="ProSearchBox">
				<div class="ProSearch">
					<input type="text" placeholder="Exhibitor name or product" v-model="ExSearch" />
					<span @click="ExhibitorSearch">Search</span>
				</div>	
			</div>
			<div>
				<div class="productlistBodyts">
					<ul id="demo">
						<li :items="live_goods_list" :index="index" v-bind:key="index" v-for="(item, index) in live_goods_list"  @click="liveshopdetails(item.url,item.store_id)">
							<div class="productlistText" v-if="item.store_id==1">
								<h3>{{item.booth}}</h3>
								<p>Live broadcasting room</p>
								<p>Will open June 28-30</p>
								<p>Coming soon</p>
							</div>
							<div v-else class="productlistImg">
								<img v-bind:src="item.store_img" />
							</div>
							<p class="BoothNumber">Booth No.:{{item.booth}}</p>
							<div class="productlistName">
								<p><span>Main Product:</span>{{item.zhuying}}</p>
							</div>
							<div class="corporateName">
								<p>{{item.company_name}}</p>
							</div>
						</li>
						
					</ul>

					<div class="Loading" v-if="Loadingshow">Loading......</div>
					<div class="Loading" v-if="NoLoadingshow">No more</div>
				</div>
				<div class="pagelistBox">
					<ul>
						<li @click="pagelist('-')">«</li>
						<li v-for="index of pagelistBox" :key="index" :class="{active:currentpage==index}"  @click="pagelist(index)">{{index}}</li>	
						<li @click="pagelist('+')">»</li>
					</ul>
				</div>
			</div>			
		</div>
		<!--分类-->
		<transition-group name="lyric">
		<div class="classificationbj"  @click="classlistshow()" v-if="classshow" :key="1"></div>
		<div class="classificationLiveBox" v-if="classshow" :key="1">
			<ul>
				<ul>
					<li v-for='(i,index) in message' @click="classprolist(i.classid,i.hall)":class="{active:currentIndex==i.classid}">{{i.classname}}</li>
				</ul>
			</ul>
		</div>
		</transition-group>
		
		
		<live-foot></live-foot>
	</div>
	
</template>

<script>
	import { getLiveInfoss } from '../../../api/memberLive'
	import LiveFoot from './child/LiveFoot'
export default {
  name: 'live_prolist',
  data () {
    return {
      classshow:false,
      live_goods_list: false,
      ExSearch:'',
      currentIndex:'100',
      Loadingshow:false,
      NoLoadingshow:false,
      classlistid:'',
      listpage:1,
      currentpage:1,
      hall:'A',
      pagelistBox:1,
      message:[{"classid":"13","classname":"LED Display","hall":"A"},{"classid":"88","classname":"Entertainment Lighting","hall":"B"},{"classid":"99","classname":"Acoustic","hall":"C"},{"classid":"15","classname":"Digital Signage","hall":"D"},{"classid":"3","classname":"Commercial Lighting","hall":"E"},{"classid":"6","classname":"Signage & Lightbox","hall":"F"},{"classid":"7","classname":"Banner Display & POP","hall":"G"},{"classid":"17","classname":"Advertising Materials & Ink","hall":"H"},{"classid":"5","classname":"Digital & Textile Printer","hall":"J"},{"classid":"16","classname":"Sign Production Equipment","hall":"K"}]
    }
  },
  components: {
    LiveFoot
  },
  mounted () {
	window.onscroll=false;
  },
  created: function () {
  	var classid=this.$route.query.class_id;
  	this.classlistid=this.$route.query.class_id;
  	this.currentIndex = classid;
	getLiveInfoss(classid, "").then((res) => {
		this.pagelistBox=res.result.page_count;
//		window.onscroll=this.pageScroll;
		this.listpage=res.result.page_count;
    	this.live_goods_list=res.result.store_list;
   }).catch(function (error) {
    })
  },
  computed: {
    
  },
  methods: {
  	//搜索
  	ExhibitorSearch:function(){
		getLiveInfoss("",this.ExSearch).then((res) => {
			this.currentpage=1;
			this.pagelistBox=res.result.page_count;
	    	this.live_goods_list=res.result.store_list;
	    })
  	},
  	//点击产品
	liveshopdetails: function (urls,item) {
		if(urls && urls!=""){
			this.$router.push({ name: 'HomeLiveShop', query: { store_id: item } })
		}else{
			
		}

   },
   //点击分类
    classprolist: function (classid,hall) {
    	this.classshow=false;
    	this.classlistid=classid;
    	this.currentIndex = classid;
    	this.currentpage=1;
    	getLiveInfoss(classid, "").then((res) => {
	    	this.live_goods_list=res.result.store_list;	  
	    	this.listpage=res.result.page_count;
	    	this.pagelistBox=res.result.page_count;
	    	this.Loadingshow = false;
    		this.NoLoadingshow=false;
//  		window.onscroll=this.pageScroll;
	    })
		this.hall=hall;
    },
    //显示/隐藏分类
    classlistshow: function(){
    	if(this.classshow){
    		this.classshow=false;
    	}else{
    		this.classshow=true;
    	}
    },
    //页码
    pagelist:function(pages){
    	
    	if(pages=="-"){
    		this.currentpage=this.currentpage-1;
    	}else if(pages=="+"){
    		this.currentpage=this.currentpage+1;
    	}else{
    		this.currentpage=pages;
    	}
    	
    	if(this.currentpage<=1){
    		this.currentpage=1;
    	}else if(this.currentpage>=this.pagelistBox){
    		this.currentpage=this.pagelistBox;
    	}else{
    		
    	}
    	getLiveInfoss(this.currentIndex,"",this.currentpage).then((res) => {
			document.body.scrollTop = document.documentElement.scrollTop = 0;
			this.pagelistBox=res.result.page_count;
	    	this.live_goods_list=res.result.store_list;
	   })
    },
    pageScroll(){
	    // 获取滚动的距离
	    let scrollTop=document.documentElement.scrollTop || document.body.scrollTop || window.pageYOffset;
	    // 获取滚动的高度（获取整个html的高度）
	    let scrollHeight=document.getElementById('demo').scrollHeight;
	    // 获取屏幕(浏览器)高度
	    let clienHeight=document.documentElement.clientHeight;
	    // 滚动的距离 + 屏幕高度 - 内容高度 >= 0 表示滚动到底部了      (下拉加载判断条件)
	    if(scrollTop+clienHeight-scrollHeight >=100){
	    	//我到底了
	    	if(this.currentpage<=this.listpage){
	    		window.onscroll=false;
	    		this.currentpage=this.currentpage+1;
	      		this.Loadingshow = true;
	    		this.prolistmore();
	    	}else{
	    		this.Loadingshow = false;
	    		this.NoLoadingshow=true;
	    		window.onscroll=false;
	    	}
	      	      
	      //滚动至底部后请求数据
	    }
	},
	prolistmore:function(){		
		getLiveInfoss(this.classlistid, "",this.currentpage).then((res) => {
	    	this.live_goods_list = this.live_goods_list.concat(res.result.store_list);
	    	window.onscroll=this.pageScroll;
	    	this.Loadingshow = false;
		}).catch(function (error) {
			
		})
	},
	loginbox:function(){
		this.$router.push({ name: 'HomeMemberLogin'})
	}
  }
}	
var _hmt = _hmt || [];
(function() {
  var hm = document.createElement("script");
  hm.src = "https://hm.baidu.com/hm.js?57728f8190d543d7cd45e84565ab5dce";
  var s = document.getElementsByTagName("script")[0]; 
  s.parentNode.insertBefore(hm, s);
})();

</script>

<style>
	.listbox{background: #fff;}
	.LogoBannerBox{padding: 0rem;overflow: auto;position: relative;}
	.LogoBannerBoxbj img{width: 100%;}
	.LogoBannerTextBox{position: absolute;bottom: 0.2rem;width: 100%;overflow: auto;}
	.LiveLogoBox{width: 40%;display: inline-block;vertical-align: bottom;}
	.LiveLogoBox img{width: 100%;}
	
	.ClassListBox{text-align: left;display: inline-block;vertical-align: bottom;width: 100%;margin-bottom: 0.3rem;}
	.ClassListBox p{display: inline-block;font-size: 0.7rem;line-height: 1.1rem;color: #FF0000;padding: 0 0.4rem;border: 1px solid #FF0000;border-radius: 5px;margin-left: 0.4rem;}
	.ClassListBox p.classlistshowst{position: relative;padding-right: 0.8rem;}
	.ClassListBox p.classlistshowst:before{position: absolute;content: "\25BC";right: 0rem;top: 0rem;}
	.ClassListBox p.classlogins{float: right;}
	.ClassListBox img{width: 1.3rem;display: inline-block;margin-left: 0.3rem;}
	.LiveProductListBoxs{padding: 1rem 0.3rem;padding-top: 0.5rem;}
	.ProSearchBox{padding: 0 0.4rem;text-align: center;}
	.ProSearch{overflow: auto;border: 1px solid #FF0000;display:block;}
	.ProSearch input{float: left;width: 80%;height: 1.7rem;line-height: 1.7rem;box-sizing: border-box;padding: 0 0.3rem;border: none;}
	.ProSearch span{font-size: 0.8rem;background: #FF0000;line-height: 1.7rem;width: 20%;display: inline-block;text-align: center;float: right;color: #fff;}
	
	.productlistBodyts{overflow: auto;padding: 0 0.3rem;}
	.productlistBodyts::-webkit-scrollbar {display: none;}
	.productlistBodyts ul{margin: 0;padding: 0;overflow: auto;display: flex;-ms-flex-wrap: wrap;flex-wrap: wrap;}
	.productlistBodyts ul li{width: 47%;margin: 0 1.5%;border: 1px solid #ccc;box-sizing: border-box;padding: 0.3rem;margin-top: 0.5rem;display: inline-block;float: left;
	border-radius: 0.3rem;padding-bottom: 0.1rem;}
	.productlistBodyts ul li .productlistImg{width:100%;margin: 0 auto;}
	.productlistBodyts ul li .productlistImg img{width: 100%;}
	.productlistName{padding: 0.4rem 0;padding-bottom: 0.2rem;}
	.productlistName p{overflow: hidden;text-overflow: ellipsis;display: -webkit-box;-webkit-line-clamp: 4;-webkit-box-orient: vertical;margin: 0;font-size: 0.5rem;line-height: 0.8rem;color: #333;min-height: 2.5rem;}
	.corporateName{border-top: 1px solid #eee;padding: 0rem;}
	.corporateName p{font-size: 0.5rem;color: #000;line-height: 1.1rem;text-overflow: ellipsis;display: -webkit-box;-webkit-line-clamp: 1;-webkit-box-orient: vertical;overflow: hidden;}
	
	.classificationbj{position: fixed;width: 100%;height: 100%;left: 0;top: 0;z-index: 9;}
	.classificationLiveBox{position: fixed;left: 0;top: 0;width: 10rem;height: 100%;z-index: 10;background: #fff;box-shadow: 5px 0px 10px #ccc;box-sizing: border-box;padding: 0rem 0;}
	.classificationLiveBox ul{margin: 0;padding: 0;padding-top: 1rem;}
	.classificationLiveBox ul li{display: block;line-height: 2rem;color: #333;font-size: 0.65rem;padding: 0 0.2rem;border-bottom: 1px solid #fff;text-align: center;box-sizing: border-box;border-left: 2px solid transparent;}
	.classificationLiveBox ul li.active{border-left-color: #FF0000;background: #f0f2f5;}
	.lyric-enter,.lyric-leave-to {opacity: 0;transform: translateY(10px);}
	.lyric-enter-to,.lyric-leave {opacity: 1;}
	.lyric-enter-active,.lyric-leave-active {transition: all 0.5s;}
	.Loading{line-height: 1rem;text-align: center;font-size: 0.8rem;margin-top: 2rem;}
	
	
	.productlistBodyts ul li .productlistText{width: 100%;height: 7.5rem;margin: 0 auto;text-align: center;background: #EEEEEE;box-sizing: border-box;padding-top: 0.3rem;}
.productlistBodyts ul li .productlistText h3{font-size: 0.9rem;line-height: 2rem;color: #a3a3a3;}
.productlistBodyts ul li .productlistText p{font-size: 0.4rem;line-height: 1rem;color: #a3a3a3;margin: 0;}
.productlistBodyts ul li p.BoothNumber{font-size: 0.6rem;padding-top: 0.2rem;color: #333;}
.corporateName p{min-height: 1.1rem;}

.pagelistBox{margin-top: 0.5rem;}
.pagelistBox ul{margin: 0;padding: 0;text-align: center;}
.pagelistBox ul li{width: 1.5rem;height: 1.5rem;box-sizing: border-box;text-align: center;font-size: 0.8rem;line-height: 1.4rem;display: inline-block;border: 1px solid #ccc;margin: 0.4rem 0.2rem;}
.pagelistBox ul li.active{background: #FF0000;color: #ffffff;}
.pagelistBox ul li:nth-child(1),.pagelistBox ul li:nth-last-child(1){font-size: 1rem;line-height: 1.2rem;}
</style>